// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-src_app_shared_enums_router-title_ennum_ts-node_modules_angular-animations_fesm2015_a-323af8":"9762bb49894a7898","src_app_features_home_home_module_ts":"7d059080f170840c","src_app_features_booking_booking_module_ts":"16b9c6a056dc81c3"}[chunkId] + ".js";
};